import { useState, useContext } from 'react';
import UserContext from '../context/UserContext';

const useForm = (state) => {
  const [inputValues, setInputValues] = useState(state);
  const [valuesFromServer, setValuesFromServer] = useState(state);
  const { setChangedDataWithoutSaving } = useContext(UserContext);

  const handleDirtyState = (name, value) => {
    const dataFromServerStingified = JSON.stringify(valuesFromServer);
    const inputValuesStringified = JSON.stringify({
      ...inputValues,
      [name]: value,
    }).replace('""', null);

    const doesKeyExistOnServer = Object.keys(valuesFromServer || {}).some(
      (key) => key === name
    );

    if (!doesKeyExistOnServer && !value) {
      setChangedDataWithoutSaving(false);
    } else {
      setChangedDataWithoutSaving(
        dataFromServerStingified !== inputValuesStringified
      );
    }
  };

  const handleChange = ({ target: { name, value } }) => {
    handleDirtyState(name, value);

    setInputValues({ ...inputValues, [name]: value });
  };

  const handleInputValues = (data, dataFromServer = true) => {
    setInputValues(data);
    if (dataFromServer) {
      setValuesFromServer(data);
    } else {
      const dataFromServerStingified = JSON.stringify(valuesFromServer);
      const inputValuesStringified = JSON.stringify(data);
      setChangedDataWithoutSaving(
        dataFromServerStingified !== inputValuesStringified
      );
    }
  };

  return [inputValues, handleChange, handleInputValues];
};

export default useForm;
